import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBBadge,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBTextArea,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBIcon,
} from "mdb-react-ui-kit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Form from "react-bootstrap/Form";

import "../sso-management.css";
import "./AppEditModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";

export class AppEditModal extends React.Component {

  constructor(props) {
    super(props);

    let dataDefault = {
      titulo: "",
      nombre: "",
      publica: 0,
      exhiEnabled: 0,
      descripcion: "",
      estado: "INCOMPLETA",
      appImg: "",
      imageUuid: "",
    };

    const incomingData = this.props.data || {};
    const normalizedData = {
      ...incomingData,
      imageUuid:
        incomingData.imageUuid ||
        incomingData.ImageUuid ||
        incomingData.image_uuid ||
        "",
    };

    let appStatusOptions = [
      { label: "ONLINE", value: "ONLINE" },
      { label: "DEMO", value: "DEMO" },
      { label: "DISABLED", value: "DISABLED" },
      { label: "INCOMPLETA", value: "INCOMPLETA" },
    ];

    this.state = {
      showAppEditModal: this.props.showAppEditModal,
      data: Object.assign(dataDefault, normalizedData),
      nuevoPermiso: "",
      selectedPermiso: "",
      permisoList: [],
      filaSeleccionada: null,
      appStatusOptions: appStatusOptions,
      // Demo Mode
      demoKeys: [],
      newKeyDescripcion: "",
      newKeyDuracion: "",
      newKeyExpiracion: "",
    };
  }

  componentDidMount() {
    this.getAppPermisions();
    if (this.state.data.IDAplicacion && this.state.data.estado === "DEMO") {
      this.getDemoKeys();
    }
    this.scrollModalToTop();
  }

  scrollModalToTop() {
    setTimeout(() => {
      const el = document.querySelector('.modal.show');
      if (el) el.scrollTop = 0;
    }, 150);
  }

  getDemoKeys() {
    doFetch("SSO", "getDemoKeys?IDAplicacion=" + this.state.data.IDAplicacion, null)
      .then((r) => r.json())
      .then((data) => {
        if (data.DATA) this.setState({ demoKeys: data.DATA });
      })
      .catch(() => {});
  }

  async generateDemoKey() {
    const body = {
      IDAplicacion: this.state.data.IDAplicacion,
      descripcion: this.state.newKeyDescripcion || null,
      duracionHoras: this.state.newKeyDuracion ? parseInt(this.state.newKeyDuracion) : null,
      fechaExpiracion: this.state.newKeyExpiracion || null,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    try {
      const response = await doFetch("SSO", "generateDemoKey", requestOptions);
      const data = await response.json();
      if (data.STATE === "SUCCESS") {
        this.setState({ newKeyDescripcion: "", newKeyDuracion: "", newKeyExpiracion: "" });
        this.getDemoKeys();
      }
    } catch (e) {
      console.error("Error generating demo key:", e);
    }
  }

  async deleteDemoKey(keyId) {
    const requestOptions = { method: "DELETE" };
    try {
      const response = await doFetch("SSO", "deleteDemoKey?IDKey=" + keyId, requestOptions);
      const data = await response.json();
      if (data.STATE === "SUCCESS") {
        this.getDemoKeys();
      }
    } catch (e) {
      console.error("Error deleting demo key:", e);
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  getAppPermisions() {
    if (this.state.data.IDAplicacion) {
      this.props.onLoading(true);

      let requestOptions = {
        method: "GET",
      };

      let method =
        "getAppPermisions?IDAplicacion=" + this.state.data.IDAplicacion;

      doFetch("SSO", method, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let permisoList = [];
          for (let dat of data.DATA) {
            permisoList.push({ label: dat.nombre, value: dat });
          }
          this.setState({ permisoList: permisoList });
        })
        .catch((error) => {
          console.error(
            "Error al obtener datos:",
            JSON.stringify(error, null, 2)
          );
        })
        .finally(() => {
          this.props.onLoading(false);
        });
    }
  }

  closeModal() {
    this.props.onCloseModal();
  }

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "publica":
        data[event.target.id] = event.target.checked ? 1 : 0;
        this.setState(data);
        break;
      case "exhiEnabled":
        data[event.target.id] = event.target.checked ? 1 : 0;
        this.setState(data);
        break;
      case "nuevoPermiso":
        this.setState({ nuevoPermiso: event.target.value });
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  handleButtonClick(index, element) {
    this.setState({ filaSeleccionada: index });
  }

  addPermiso(event) {
    if (this.state.nuevoPermiso) {
      if (!this.state.permisoList.includes(this.state.nuevoPermiso)) {
        let permisoList = this.state.permisoList;

        permisoList.push({
          label: this.state.nuevoPermiso,
          value: { nombre: this.state.nuevoPermiso },
        });

        this.setState({
          permisoList: permisoList,
          nuevoPermiso: "",
          filaSeleccionada: null,
        });
      }
    }
  }

  delPermiso(event) {
    if (this.state.filaSeleccionada != null) {
      let permisoList = this.state.permisoList;
      permisoList.splice(this.state.filaSeleccionada, 1);
      this.setState({
        permisoList: permisoList,
        filaSeleccionada: null,
      });
    }
  }

  async doSave(event) {
    event.preventDefault();

    if (!this.state.data.nombre || !this.state.data.nombre.trim()) {
      alert("El nombre de la aplicación es obligatorio");
      return;
    }

    if (!this.state.data.titulo || !this.state.data.titulo.trim()) {
      alert("El título de la aplicación es obligatorio");
      return;
    }

    const isCreateMode = !this.state.data.IDAplicacion;

    let res;
    if (isCreateMode) {
      res = await this.createApp();
    } else {
      res = await this.updateApp();
      res = res ? await this.updateAppPermissions() : res;
    }

    if (res) {
      this.props.onCloseModal();
    }
  }

  async createApp() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.data),
    };

    await doFetch("SSO", "insertApp", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async updateApp() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.data),
    };

    this.props.onLoading(true);

    await doFetch("SSO", "updateApp", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async updateAppPermissions() {
    let result = false;

    this.props.onLoading(true);

    let permisoList = [];
    for (let permiso of this.state.permisoList) {
      permisoList.push(permiso.value);
    }

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(permisoList),
    };

    let method =
      "updateAppPermissions?IDAplicacion=" + this.state.data.IDAplicacion;

    this.props.onLoading(true);

    await doFetch("SSO", method, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  handleMfmImageUpload = (result) => {
    this.setState((prev) => ({
      data: {
        ...prev.data,
        imageUuid: result?.uuid || "",
        appImg: "",
      },
    }));
  };

  handleMfmImageDelete = () => {
    this.setState((prev) => ({
      data: {
        ...prev.data,
        imageUuid: "",
        appImg: "",
      },
    }));
  };

  setShow(event) {
    if (this.state.showAppEditModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  render() {
    return (
      <>
        <MDBModal
          show={this.state.showAppEditModal}
          setShow={(event) => this.setShow(event)}
          tabIndex="-1"
        >
          <MDBModalDialog size="xl">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle style={{ fontSize: "1.05rem" }}>
                  <MDBIcon fas icon={this.state.data.IDAplicacion ? "edit" : "plus-circle"} className="me-2" />
                  {this.state.data.IDAplicacion ? this.state.data.titulo : "Nueva aplicación"}
                </MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer className="sso-modal-form">
                  {/* ── Datos de la aplicación ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="th-large" className="me-2" />
                    Datos de la aplicación
                  </h6>
                  <MDBRow>
                    <MDBCol md="3">
                      <MfmImageUploader
                        uuid={this.state.data.imageUuid || null}
                        img={this.state.data.appImg || ""}
                        appCode="SSO"
                        library="apps"
                        mediaType="image"
                        mediaFormat="1/1"
                        mediaFrameSize="240x240"
                        onUpload={this.handleMfmImageUpload}
                        onDelete={this.handleMfmImageDelete}
                      />
                    </MDBCol>
                    <MDBCol md="9">
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="titulo"
                            label="Título"
                            value={this.state.data.titulo}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="nombre"
                            label="Código (nombre técnico)"
                            value={this.state.data.nombre}
                            onChange={(event) => this.handleChange(event)}
                            disabled={!!this.state.data.IDAplicacion}
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="4">
                          <Form.Label htmlFor="estado" style={{ fontSize: "0.82rem" }}>Estado</Form.Label>
                          <Form.Select
                            size="sm"
                            id="estado"
                            value={this.state.data.estado}
                            onChange={(event) => {
                              this.handleChange(event);
                              // Load demo keys when switching to DEMO
                              if (event.target.value === "DEMO" && this.state.data.IDAplicacion && this.state.demoKeys.length === 0) {
                                this.getDemoKeys();
                              }
                            }}
                          >
                            {this.state.appStatusOptions.map(
                              (element, index) => (
                                <option key={index} value={element.value}>
                                  {element.label}
                                </option>
                              )
                            )}
                          </Form.Select>
                        </MDBCol>
                        <MDBCol md="4" className="d-flex align-items-center pt-3">
                          <MDBSwitch
                            id="publica"
                            label="Pública"
                            checked={this.state.data.publica}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        {this.state.data.nombre !== "EXHI" && (
                          <MDBCol md="4" className="d-flex align-items-center pt-3">
                            <MDBSwitch
                              id="exhiEnabled"
                              label="Exhibiciones habilitadas"
                              checked={!!this.state.data.exhiEnabled}
                              onChange={(event) => this.handleChange(event)}
                            />
                          </MDBCol>
                        )}
                      </MDBRow>
                      <MDBRow className="mt-3">
                        <MDBCol md="12">
                          <MDBTextArea
                            className="mb-3"
                            rows={3}
                            id="descripcion"
                            label="Descripción"
                            value={this.state.data.descripcion}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  {/* ── Permisos ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="key" className="me-2" />
                    Permisos
                  </h6>
                  <MDBRow className="g-3">
                    <MDBCol md="7">
                      <div style={{ maxHeight: "240px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px" }}>
                        <MDBTable align="middle" hover className="sso-mgmt-table mb-0">
                          <MDBTableBody>
                            {this.state.permisoList.length === 0 ? (
                              <tr><td className="text-center text-muted" style={{ fontSize: "0.82rem", padding: "1rem" }}>Sin permisos definidos</td></tr>
                            ) : (
                              this.state.permisoList.map((element, index) => (
                                <tr
                                  key={index}
                                  onClick={() => this.handleButtonClick(index, element)}
                                  style={{
                                    backgroundColor: this.state.filaSeleccionada === index ? "rgba(0, 102, 192, 0.15)" : "transparent",
                                    cursor: "pointer",
                                  }}
                                >
                                  <td style={{ padding: "0.4rem 0.65rem" }}>
                                    <MDBIcon fas icon="shield-alt" className="me-2 text-muted" style={{ fontSize: "0.7rem" }} />
                                    <span style={{ fontSize: "0.85rem" }}>{element.label}</span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </MDBCol>
                    <MDBCol md="5">
                      <MDBInput
                        className="mb-2"
                        type="text"
                        size="sm"
                        id="nuevoPermiso"
                        label="Nuevo permiso"
                        value={this.state.data.nuevoPermiso}
                        onChange={(event) => this.handleChange(event)}
                      />
                      <MDBBtn size="sm" onClick={(event) => this.addPermiso(event)} block className="mb-2"
                        disabled={!this.state.nuevoPermiso || !this.state.nuevoPermiso.trim()}>
                        <MDBIcon fas icon="plus" className="me-1" /> Añadir
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        onClick={(event) => this.delPermiso(event)}
                        disabled={this.state.filaSeleccionada == null}
                        color="danger"
                        outline
                        block
                      >
                        <MDBIcon fas icon="trash" className="me-1" /> Eliminar seleccionado
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>

                  {/* ── Modo Demo — Claves de acceso ── */}
                  {this.state.data.estado === "DEMO" && this.state.data.IDAplicacion ? (
                    <>
                      <h6 className="sso-section-title">
                        <MDBIcon fas icon="flask" className="me-2" />
                        Claves de acceso demo
                      </h6>
                      {this.state.demoKeys.length === 0 ? (
                        <p className="text-muted" style={{ fontSize: "0.82rem" }}>No hay claves de acceso creadas.</p>
                      ) : (
                        <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px" }}>
                          <MDBTable align="middle" hover className="sso-mgmt-table mb-0">
                            <MDBTableHead>
                              <tr>
                                <th>Clave</th>
                                <th>Descripción</th>
                                <th>Duración</th>
                                <th>Expira</th>
                                <th style={{ width: "80px" }}>Acciones</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {this.state.demoKeys.map((k, i) => (
                                <tr key={i} style={{ opacity: k.activa ? 1 : 0.45 }}>
                                  <td style={{ fontFamily: "monospace", fontSize: "0.82rem" }}>
                                    {k.clave}
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Copiar</Tooltip>}>
                                      <span className="d-inline-block">
                                        <MDBIcon fas icon="copy" className="ms-2 text-primary" style={{ cursor: "pointer", fontSize: "0.7rem" }}
                                          onClick={() => this.copyToClipboard(k.clave)} />
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td>{k.descripcion || <span className="text-muted">—</span>}</td>
                                  <td>{k.duracionHoras ? k.duracionHoras + "h" : "Indefinida"}</td>
                                  <td>
                                    {k.fechaExpiracion ? new Date(k.fechaExpiracion).toLocaleDateString() : "Sin expiración"}
                                  </td>
                                  <td className="sso-actions-cell">
                                    {k.activa ? (
                                      <OverlayTrigger placement="top" overlay={<Tooltip>Revocar</Tooltip>}>
                                        <span className="d-inline-block">
                                          <MDBBtn color="danger" outline floating size="sm"
                                            onClick={() => this.deleteDemoKey(k.IDKey)}>
                                            <MDBIcon icon="times" />
                                          </MDBBtn>
                                        </span>
                                      </OverlayTrigger>
                                    ) : (
                                      <MDBBadge color="secondary" pill>Revocada</MDBBadge>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      )}
                      <MDBRow className="mt-3 g-2 align-items-end">
                        <MDBCol md="4">
                          <MDBInput size="sm" label="Descripción (opcional)"
                            value={this.state.newKeyDescripcion}
                            onChange={(e) => this.setState({ newKeyDescripcion: e.target.value })} />
                        </MDBCol>
                        <MDBCol md="2">
                          <MDBInput size="sm" type="number" label="Duración (horas)"
                            value={this.state.newKeyDuracion}
                            onChange={(e) => this.setState({ newKeyDuracion: e.target.value })} />
                        </MDBCol>
                        <MDBCol md="3">
                          <MDBInput size="sm" type="datetime-local" label="Expira en"
                            value={this.state.newKeyExpiracion}
                            onChange={(e) => this.setState({ newKeyExpiracion: e.target.value })} />
                        </MDBCol>
                        <MDBCol md="3">
                          <MDBBtn size="sm" block onClick={() => this.generateDemoKey()}>
                            <MDBIcon fas icon="plus" className="me-1" /> Generar clave
                          </MDBBtn>
                        </MDBCol>
                      </MDBRow>
                    </>
                  ) : null}

                  <div className="sso-modal-save-bar">
                    <MDBBtn onClick={(event) => this.doSave(event)}>
                      <MDBIcon fas icon="save" className="me-2" />
                      Guardar
                    </MDBBtn>
                  </div>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
